module.exports = __webpack_public_path__ + "img/category-experiment2.28344d41.svg";